export default "__VITE_ASSET__ea022251__"